module.exports = __webpack_public_path__ + "static/anana-vestige-journal-intro-background-568613797f5707c027e465fa90d1f2fa.jpg";